import { Injectable } from '@angular/core';
import { AuthConfig } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private readonly accessTokenKey = 'access_token';

  setAccessToken(token: string) {
    localStorage.setItem(this.accessTokenKey, token);
  }

  getAccessToken(): string | null {
    return localStorage.getItem(this.accessTokenKey);
  }

  isAuthenticated(): boolean {
    const hasToken = !!this.getAccessToken();
    return window.location.hostname === 'localhost' || hasToken;
  }

  logout() {
    localStorage.removeItem(this.accessTokenKey);
    localStorage.removeItem('userId');
  }

  getAuthUrl(): string {
    if (AuthConfig.realmPath.includes('internet')) {
      return `${AuthConfig.AMBaseURL}/oauth2/${AuthConfig.realmPath}/authorize?authIndexType=service&authIndexValue=strongAuth4000Service&client_id=${AuthConfig.clientId}&state=${AuthConfig.state}&scope=${AuthConfig.scopes}&redirect_uri=${AuthConfig.redirectUri}&response_type=token%20id_token&nonce=${AuthConfig.nonce}&acr_values=strongAuth4000Service`;
    }
    return `${AuthConfig.AMBaseURL}/oauth2/${AuthConfig.realmPath}/authorize?client_id=${AuthConfig.clientId}&state=${AuthConfig.state}&scope=${AuthConfig.scopes}&redirect_uri=${AuthConfig.redirectUri}&response_type=token%20id_token&nonce=${AuthConfig.nonce}`;
  }

  handleRedirect() {
    if (sessionStorage.getItem('redirectHandled')) return;

    const hash = window.location.hash;
    if (hash) {
      const params = new URLSearchParams(hash.substring(1));
      const accessToken = params.get('access_token');
      if (accessToken) {
        localStorage.clear();
        this.setAccessToken(accessToken);
        sessionStorage.setItem('redirectHandled', 'true');
        // Remove the hash from the URL before reload
        history.replaceState(
          null,
          '',
          window.location.pathname + window.location.search
        );
        window.location.reload();
        return;
      }
    }
    window.location.href = this.getAuthUrl();
  }

  handleRefreshRedirect() {
    window.location.href = this.getAuthUrl();
  }
}
